import { createTheme } from '@mui/material/styles';
import red from '@mui/material/colors/red';

// Create a theme instance.
export const theme = createTheme({
  palette: {
    primary: {
      main: '#00968c',
    },
    secondary: {
      main: '#3cccc5',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
});
